module.exports = __webpack_public_path__ + "static/media/free.23af3c15.png";